import React from "react"
import { Checkbox, Grid } from "@material-ui/core"
import { VerifiedUserOutlined as ShieldIcon } from "@material-ui/icons"

import { Text } from "letalkui"

import RoleGroupPermissionGate from "@/components/PermissionGate/RoleGroupPermissionGate"

import useStyles from "@/pages/Admin/Role/RoleDetails/AdminAccessRow/styles"

type AdminAccessRowProps = {
	checked: boolean
	onChange: (checked: boolean) => void
}

const AdminAccessRow: React.FC<AdminAccessRowProps> = (props) => {
	const { checked, onChange } = props

	const classes = useStyles()

	return (
		<Grid container alignItems="flex-start" wrap="nowrap" className={classes.row}>
			<Grid item className={classes.iconBox}>
				<ShieldIcon className={classes.icon} />
			</Grid>

			<Grid item style={{ flex: 1 }}>
				<Grid container alignItems="center" style={{ gap: "9px" }}>
					<Text.Body type="default" fontWeight="bold" className={classes.title}>Administrador</Text.Body>
					<span className={classes.badge}>Acesso total</span>
				</Grid>
				<Grid item>
					<Text.Body type="small2" className={classes.description}>
						Concede acesso total ao sistema, independentemente das demais permissões.
					</Text.Body>
				</Grid>
			</Grid>

			<Grid item>
				<RoleGroupPermissionGate action="update">
					<Checkbox
						color="primary"
						checked={checked}
						onChange={(_, isChecked) => onChange(isChecked)}
					/>
				</RoleGroupPermissionGate>
			</Grid>
		</Grid>
	)
}

export default AdminAccessRow
